import { capfirst, intword, intcomma } from 'journalize';

const PARTY_SORT_ORDER = [
  'Republican',
  'Democrat',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

function format(num) {
  return num < 10 ? '0' + num : num;
}

export function determineDistrictTitle(contest) {
  return `${determineOffice(contest.office)} ${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineDistrictTitleYourRaces(contest) {
  return `${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : contest.office + ' ' + capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest) {
  if (
    contest.division_type === 'statewide' ||
    contest.division_type === 'seat' ||
    contest.division_type === 'class'
  )
    return '';

  return determineDistrictTitle(contest);
}

export function roundThousands(num) {
  var integer = 1000;
  if (num < 1000000)return intcomma(Math.round(num / integer) * integer)
  else return intword(num)
}

export function determineOffice(office) {
  return `${
    office === 'State Board of Education'
      ? 'SBOE'
      : office === 'Texas Supreme Court'
      ? 'Supreme Court'
      : office === 'Texas Court of Criminal Appeals'
      ? 'Criminal Appeals'
      : office === 'Texas Senate'
      ? 'Senate'
      : office === 'Texas House'
      ? 'House'
      : office
  }`.trim();
}

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}